<template>
  <div>
    <!-- <left-menu-admin
      ref="modal"
      menuActive="0"
      :sessionData="session"
    ></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <div v-if="res.length < Limit">
          <v-alert
            v-if="res.length >= warningLimit"
            :value="alert"
            dense
            border="left"
            type="warning"
          >
            <v-row align="center">
              <v-col class="grow"> จำนวนสมาชิกใกล้จะครบที่กำหนด </v-col>
              <v-col class="shrink">
                <v-btn @click="changePacket()">แพคเกจ</v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </div>
        <div v-if="res.length >= Limit">
          <v-alert
            v-if="res.length >= Limit"
            :value="alert"
            dense
            outlined
            type="error"
          >
            <v-row align="center">
              <v-col class="grow"> จำนวนสมาชิกครบที่กำหนด </v-col>
              <v-col class="shrink">
                <v-btn @click="changePacket()" color="red">แพคเกจ</v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </div>
        <v-row>
          <v-col cols="6" md="6" sm="12" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" md="6" sm="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              :disabled="statusLimit"
              @click="
                (dialogAdd = true),
                  getDataBranch(),
                  validate('ADD'),
                  chkaddFilterItem(),
                  chkaddProductExchangeRate();
              "
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
            <!-- <v-btn
              color="pink"
              sm="6"
              dark
              depressed
              @click="dialogRedeem = true"
            >
              <v-icon left>mdi-gift-open</v-icon>
              Redeem
            </v-btn> -->
          </v-col>
        </v-row>
        <v-row>
          <v-dialog v-model="dialogRedeem" width="500">
            <v-card>
              <v-row class="fullscreen">
                <!-- <v-row class="fullscreen"> -->
                <qrcode-stream
                  :camera="camera"
                  @decode="onDecode"
                  @init="onInit"
                >
                  <v-dialog v-model="showScanConfirmation" width="500">
                    <v-card>
                      <v-card-text class="text-center">
                        <img
                          src="../../assets/checkmark.png"
                          alt="Checkmark"
                          height="128px"
                          width="128px"
                        />
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </qrcode-stream>
              </v-row>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dailogViewRedeem" persistent max-width="400">
            <v-card>
              <v-card-title>
                <span class="headline">ยืนยันรางวัล</span>
              </v-card-title>
              <v-card-text v-if="!statusViewRedeem">
                <v-alert dense outlined type="error">
                  <strong>Data not found</strong>
                </v-alert>
              </v-card-text>
              <v-card-text v-if="statusViewRedeem">
                <v-container>
                  <b>ข้อมูลรางวัล</b>
                  <v-row>
                    <v-col class="text-center">
                      <v-img
                        :src="formView.rewardPictureUrl"
                        max-width="90"
                      ></v-img>
                      <!-- <span class="shopname">{{session.data.name}}</span> -->
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description"
                            ><b>รางวัล :</b> {{ formView.rewardName }}</span
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="pt-0 pb-0"
                          ><span class="description">
                            {{ formView.rewardSubName }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                  <br />
                  <b>ข้อมูลลูกค้า</b>
                  <v-row>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description"
                            ><b>ชื่อลูกค้า :</b> {{ formView.lineName }}</span
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="pt-0 pb-0"
                          ><span class="description"
                            ><b>ระดับ :</b> {{ formView.levelName }}</span
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="pt-0 pb-0"
                          ><span class="description"
                            ><b>คะแนนทั้งหมด :</b>
                            {{ formView.currentPoint }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                    <v-col class="text-center">
                      <v-img :src="formView.linePicture" max-width="90"></v-img>
                      <!-- <span class="shopname">{{session.data.name}}</span> -->
                    </v-col>
                    <!-- <v-col class="pt-3 pb-0 text-center">ชื่อลูกค้า {{formView.lineName}}</v-col> -->
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea
                        auto-grow
                        rows="2"
                        name="input-7-4"
                        label="หมายเหตุ"
                        counter
                        dense
                        outlined
                        v-model="formView.description"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                      <v-col class="pa-4 text-center">{{formAdd.point}}</v-col>
                    </v-row> -->
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  @click="closeViewRedeem()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="green darken-1"
                  v-if="statusViewRedeem"
                  @click="updateUseRerard()"
                >
                  <v-icon left> mdi-content-save-all</v-icon>
                  ยืนยัน
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="40%">
            <v-card class="text-center" width="100%">
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click="
                        (dialogAdd = false),
                          clearData(),
                          (dialogExchang = false);
                      "
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row class="mb-6" justify="center">
                    <v-col md="auto">
                      <v-img
                        class="v-img-margit"
                        :src="require('@/assets/qricon.png')"
                      ></v-img>
                    </v-col>
                  </v-row>
                  <v-row class="mb-6" justify="center">
                    <v-col md="auto">
                      <v-img
                        class="v_text_add"
                        :src="require('@/assets/Grouptitle.png')"
                      ></v-img>
                    </v-col>
                  </v-row>
                  <!-- card -->
                  <!-- Operation No v -->
                  <v-card
                    max-width="600"
                    class="mx-auto"
                    v-show="formAdd.productExchangeRateId === ''"
                    v-if="
                      session.data.userTypeGroup === 'Operation' &&
                        session.data.shopId !==
                          'Uc520945108b983b6e739ed0a8cd8dae4'
                    "
                  >
                    <v-container>
                      <v-row dense>
                        <v-col
                          v-for="(item, i) in filterItem"
                          :key="i"
                          cols="6"
                        >
                          <v-card color="#1b437c" dark>
                            <v-card-title>
                              <h3 class="mx-start">
                                <b>{{ item.text }}</b>
                              </h3>
                            </v-card-title>
                            <div
                              class="d-flex flex-no-wrap justify-space-between"
                            >
                              <div>
                                <v-card-subtitle>
                                  <h5 class="ml-6">
                                    อัตราแลกเปลี่ยน 1 คะแนน ต่อ
                                    {{ item.exchangeRate }} บาท
                                  </h5>
                                </v-card-subtitle>
                              </div>
                            </div>
                            <v-card-actions>
                              <v-btn
                                class="mx-auto"
                                text
                                dark
                                color="primary"
                                @click="addExchange(item)"
                              >
                                เลือก
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <!-- card-Admin -->
                  <v-div
                    max-width="800"
                    class="mx-auto"
                    v-show="this.formAdd.productExchangeRateId === ''"
                    v-if="
                      session.data.userTypeGroup === 'Operation' &&
                        session.data.shopId ===
                          'Uc520945108b983b6e739ed0a8cd8dae4'
                    "
                  >
                    <v-container>
                      <v-row dense pt-3>
                        <v-col
                          v-for="(item, i) in ProductExchangeRate"
                          :key="i"
                          cols="6"
                        >
                          <div>
                            <v-card color="#1b437c" dark>
                              <v-card-title>
                                <h3 class="ml-5 mt-2">{{ item.text }}</h3>
                              </v-card-title>
                              <div
                                class="
                                    d-flex
                                    flex-no-wrap
                                    justify-space-between
                                  "
                              >
                                <div>
                                  <v-card-subtitle>
                                    <h5 class="ml-6">
                                      อัตราแลกเปลี่ยน 1 ต่อ
                                      {{ item.exchangeRate }} บาท
                                    </h5>
                                  </v-card-subtitle>
                                </div>
                              </div>
                              <v-card-actions>
                                <v-btn
                                  class="mx-auto"
                                  text
                                  @click="addExchange(item), getDataBranch()"
                                >
                                  เลือก
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-div>

                  <v-div
                    max-width="800"
                    class="mx-auto"
                    v-show="this.formAdd.productExchangeRateId === ''"
                    v-if="session.data.userTypeGroup !== 'Operation'"
                  >
                    <v-container>
                      <v-row dense pt-3>
                        <v-col
                          v-for="(item, i) in ProductExchangeRate"
                          :key="i"
                          cols="6"
                        >
                          <div>
                            <v-card color="#1b437c" dark>
                              <v-card-title>
                                <h3 class="ml-5 mt-2">{{ item.text }}</h3>
                              </v-card-title>
                              <div
                                class="
                                    d-flex
                                    flex-no-wrap
                                    justify-space-between
                                  "
                              >
                                <div>
                                  <v-card-subtitle>
                                    <h5 class="ml-6">
                                      อัตราแลกเปลี่ยน 1 คะแนน ต่อ
                                      {{ item.exchangeRate }} บาท
                                    </h5>
                                  </v-card-subtitle>
                                </div>
                              </div>
                              <v-card-actions>
                                <v-btn
                                  class="mx-auto"
                                  text
                                  @click="addExchange(item), getDataBranch()"
                                >
                                  เลือก
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-div>
                  <v-form
                    ref="form_add"
                    v-model="validAdd"
                    lazy-validation
                    v-show="this.formAdd.productExchangeRateId !== ''"
                  >
                    <!-- {{ProductExchangeRate}} -->
                    <v-col cols="12">
                      <v-row style="height: 60px">
                        <v-text-field
                          v-if="session.data.userTypeGroup !== 'Operation'"
                          v-model="Exchange"
                          dense
                          disabled
                          outlined
                          :rules="[rules.required]"
                          label="สินค้า/บริการ"
                        ></v-text-field>
                        <v-text-field
                          v-if="session.data.userTypeGroup === 'Operation'"
                          v-model="Exchange"
                          disabled
                          dense
                          outlined
                          :rules="[rules.required]"
                          label="สินค้า/บริการ"
                        ></v-text-field>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row style="height: 60px">
                        <VuetifyMoney
                          v-model="formAdd.amount"
                          label="จำนวนเงิน"
                          dense
                          outlined
                          required
                          :rules="[rules.required]"
                          v-bind:options="options2"
                        />
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row style="height: 60px">
                        <v-text-field
                          v-model="formAdd.tel"
                          dense
                          v-mask="'###-###-####'"
                          outlined
                          :rules="[rules.required]"
                          label="เบอร์โทรศัพท์"
                        ></v-text-field>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row style="height: 60px">
                        <v-select
                          v-model="formAdd.masBranchID"
                          :items="dataBranch"
                          label="สาขา"
                          dense
                          outlined
                          :rules="[rules.required]"
                        ></v-select>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row style="height: 60px">
                        <v-text-field
                          v-model="formAdd.refId"
                          label="เลขอ้างอิงลูกค้า"
                          dense
                          outlined
                        ></v-text-field>
                      </v-row>
                    </v-col>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      color="#173053"
                      :disabled="!validAdd"
                      :loading="loadingAdd"
                      @click="addData(), filter(), getDataBranch()"
                    >
                      <!-- addData(), filter(), getDataBranch() -->
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      เพิ่ม
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- view add -->
          <v-dialog v-model="dialogViewAdd" persistent max-width="40%">
            <v-card>
              <v-card-title class="text-center">
                Scan เพื่อรับคะแนน
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col class="text-center">
                      <v-img :src="session.data.logo" max-width="50"></v-img>
                      <span class="mr-16 shopname">{{
                        session.data.name
                      }}</span>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description" id="text_a"
                            >วันที่
                            {{ format_dateNotime(formAdd.CREATE_DATE) }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-divider
                    color="#FFA000"
                    style="margin-bottom: 10px"
                  ></v-divider>
                  <v-row>
                    <v-col class="text-center">
                      <v-row style="height: 60px">
                        <v-text-field
                          v-model="formAdd.qrCodeURL"
                          placeholder="Copy Link"
                          ref="textToCopyformViewAdd"
                          dense
                          outlined
                          readonly
                        ></v-text-field>
                        <v-col cols="1" xs="1" sm="1" md="1" lg="1">
                          <v-btn
                            color="primary"
                            fab
                            x-small
                            dark
                            @click="copyTextformViewAdd"
                            ><v-icon>mdi-content-copy</v-icon></v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-center">
                      <!-- {{ formUpdate.qrCodeURL }} -->
                      <qrcode-vue
                        style="margin-top: 50px"
                        :value="formAdd.qrCodeURL"
                        :size="size"
                        level="H"
                      ></qrcode-vue>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-3 pb-0 text-center"
                      ><span class="summary" id="text_a"
                        >ได้คะแนนเพิ่ม</span
                      ></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col class="pa-4 text-center"
                      ><span class="point s-4" id="text_b">{{
                        formAdd.point
                      }}</span></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col class="pa-0 text-center"
                      ><span class="summary" id="text_a">คะแนน</span></v-col
                    >
                  </v-row>
                  <v-divider color="#C4C4C4"></v-divider>
                  <v-row>
                    <v-col class="pt-3 pb-0">
                      <span class="description" id="text_a">ยอดเงิน: </span>
                    </v-col>
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >{{ formAdd.amount }} บาท</span
                      >
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 1px">
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >+ {{ formAdd.point }} คะแนน</span
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="blue darken-1"
                  @click="
                    (dialogAdd = false),
                      (dialogViewAdd = false),
                      clearData(),
                      getDataGlobal(
                        DNS_IP,
                        path,
                        session.data.shopId + '&status=waiting'
                      );
                  "
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end view -->

          <!-- view -->
          <v-dialog v-model="dialogView" persistent max-width="40%">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click="
                        (dialogView = false),
                          getDataGlobal(
                            DNS_IP,
                            path,
                            session.data.shopId + '&status=waiting'
                          );
                      "
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row>
                    <v-col class="text-center">
                      <v-img :src="session.data.logo" max-width="50"></v-img>
                      <span class="mr-16 shopname">{{
                        session.data.name
                      }}</span>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description" id="text_a"
                            >วันที่
                            {{ format_date(formUpdate.CREATE_DATE) }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-divider
                    color="#FFA000"
                    style="margin-bottom: 10px"
                  ></v-divider>
                  <v-row>
                    <v-col class="text-center">
                      <v-row style="height: 60px">
                        <v-text-field
                          v-model="formUpdate.qrCodeURL"
                          placeholder="Copy Link"
                          ref="textToCopyformUpdate"
                          dense
                          outlined
                          readonly
                        ></v-text-field>
                        <v-col cols="1" xs="1" sm="1" md="1" lg="1">
                          <v-btn
                            color="primary"
                            fab
                            x-small
                            dark
                            @click="copyTextformUpdate"
                            ><v-icon>mdi-content-copy</v-icon></v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-center">
                      <!-- {{ formUpdate.qrCodeURL }} -->
                      <qrcode-vue
                        style="margin-top: 50px"
                        :value="formUpdate.qrCodeURL"
                        :size="size"
                        level="H"
                      ></qrcode-vue>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-3 pb-0 text-center"
                      ><span class="summary" id="text_a"
                        >ได้คะแนนเพิ่ม</span
                      ></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col class="pa-4 text-center"
                      ><span class="point s-4" id="text_b">{{
                        formUpdate.point
                      }}</span></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col class="pa-0 text-center"
                      ><span class="summary" id="text_a">คะแนน</span></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col class="pa-4 text-center" v-if="formUpdate.refId">
                      <label>เลขอ้างอิงลูกค้า</label>
                      <span>{{ formUpdate.refId }}</span></v-col
                    >
                  </v-row>
                  <v-divider color="#C4C4C4"></v-divider>
                  <v-row>
                    <v-col class="pt-3 pb-0">
                      <span class="description" id="text_a">ยอดเงิน: </span>
                    </v-col>
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >{{ formUpdate.amount }} บาท</span
                      >
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 1px">
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >+ {{ formUpdate.point }} คะแนน</span
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="#173053"
                  @click="
                    (dialogView = false),
                      getDataGlobal(
                        DNS_IP,
                        path,
                        session.data.shopId + '&status=waiting'
                      );
                  "
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end view -->

          <!-- <v-dialog
        v-model="dialogPhoneNumber"
        max-width="25%"
        class="scoll"
      >
        <v-card style="width: 100%; height: 80%;">
          <v-col class="text-right">
                      <v-btn
                      outlined
                      fab
                      color="teal"
                      @click="dialogPhoneNumber = false"
                      >
                      <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  <v-avatar class="avatar" size="130">
                  <img alt="user" :src="this.dataFilterTel.picture" />
                  </v-avatar>
          <v-card-title class="text-h5 text-center">
            ยืนยันข้อมูล
          </v-card-title>

          <v-card-text>
            <v-row>
                          <v-col cols="12">
                              <h3>{{dataFilterTel.nameCustomer}}</h3>
                              <h3>{{dataFilterTel.tel}}</h3>
                          </v-col>
                      </v-row>
          </v-card-text>

          <v-card-actions>
            <v-row class="text-center divBtn">
                                  <v-btn
                                  color="#20C92F"
                                  rounded
                                  x-large
                                  dark
                                  @click="conF"
                              >
                                  บันทึกข้อมูล
                              </v-btn>
                      </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
          <v-dialog
            v-model="dialogPhoneNumber"
            persistent
            max-width="550px"
            style=""
          >
            <v-card
              class="text-center v-card-chk"
              style="background-color:;height:545px"
            >
              <v-col class="text-right">
                <v-btn
                  outlined
                  small
                  fab
                  color="teal"
                  @click="
                    dialogPhoneNumber = false;
                    dialogAdd = true;
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-avatar
                class="avatar"
                size="150"
                style="box-shadow: 0px 18px 40px rgba(112, 144, 176, 0.12); padding: 10px 10px;"
              >
                <img alt="user" :src="this.dataFilterTel.picture" />
              </v-avatar>
              <v-col>
                <h2
                  style="color: #1B2559; font-family: Kanit !important ; font-size: 35px !important;font-style: normal;font-weight: 700;"
                >
                  ยืนยันข้อมูล
                </h2>
              </v-col>
              <v-row>
                <v-col cols="12">
                  <h3
                    style="color: #A3AED0; font-family: Kanit !important ; font-size: 25px !important;"
                    v-if="dataFilterTel.nameCustomer"
                  >
                    {{ dataFilterTel.nameCustomer }}
                  </h3>
                  <h3
                    style="color: #A3AED0; font-family: Kanit !important ; font-size: 25px !important;"
                    v-else
                  >
                    {{ dataFilterTel.name }}
                  </h3>
                  <h3
                    style="color: #A3AED0; font-family: Kanit !important ; font-size: 25px !important;"
                  >
                    {{ dataFilterTel.tel }}
                  </h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="text-center divBtn">
                    <v-btn
                      style="width: 240px; padding-top: 9px;"
                      rounded
                      color="#20C92F"
                      x-large
                      dark
                      @click="conF"
                      ><h6
                        style="font-family: Kanit !important ;font-size: 20px !important;"
                      >
                        บันทึกข้อมูล
                      </h6>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="40%">
            <v-card class="text-center">
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click="
                        (dialogEdit = false),
                          getDataGlobal(
                            DNS_IP,
                            path,
                            session.data.shopId + '&status=waiting'
                          );
                      "
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row class="mb-6" justify="center">
                    <v-col md="auto">
                      <v-img
                        class="v_text_edit"
                        :src="require('@/assets/GroupEditTitle.svg')"
                      ></v-img>
                    </v-col>
                  </v-row>
                  <div class="text-center" style="margin-top: 15px">
                    <qrcode-vue
                      :value="formUpdate.qrCodeURL"
                      :size="size"
                      level="H"
                    ></qrcode-vue>
                  </div>
                  <v-form
                    ref="form_update"
                    v-model="validUpdate"
                    lazy-validation
                  >
                    <v-row style="margin-left: 2px">
                      <v-col cols="12">
                        <v-row style="height: 15px">
                          <v-subheader id="subtext">สาขา</v-subheader>
                        </v-row>
                        <v-row style="height: 60px">
                          <v-select
                            v-model="formUpdate.masBranchID"
                            :items="dataBranch"
                            placeholder="สาขา"
                            dense
                            :rules="[rules.required]"
                          ></v-select>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 60px">
                          <v-select
                            v-model="formUpdate.productExchangeRateId"
                            :items="ProductExchangeRate"
                            dense
                            placeholder="สินค้า/บริการ"
                            label="สินค้า/บริการ"
                          ></v-select>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 15px">
                          <v-subheader id="subtext">จำนวน</v-subheader>
                        </v-row>
                        <v-row style="height: 60px">
                          <VuetifyMoney
                            v-model="formUpdate.amount"
                            placeholder="Amount"
                            dense
                            required
                            :rules="[rules.required]"
                            v-bind:options="options2"
                          />
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row style="margin-left: 2px">
                      <v-col cols="6">
                        <v-row style="height: 15px">
                          <v-subheader id="subtext">คะแนน</v-subheader>
                        </v-row>
                        <v-row style="height: 60px">
                          <VuetifyMoney
                            v-model="formUpdate.point"
                            placeholder="Point"
                            dense
                            required
                            disabled
                            :rules="[rules.required]"
                            v-bind:options="options2"
                          />
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 15px">
                          <v-subheader id="subtext"
                            >เลขอ้างอิงลูกค้า</v-subheader
                          >
                        </v-row>
                        <v-row style="height: 40px">
                          <v-text-field
                            v-model="formUpdate.refId"
                            placeholder="เลขอ้างอิงลูกค้า"
                            dense
                          ></v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-col cols="12">
                      <v-row style="height: 15px">
                        <v-subheader id="subtext">COPY LINK</v-subheader>
                      </v-row>
                      <v-row style="height: 60px">
                        <v-text-field
                          v-model="formUpdate.qrCodeURL"
                          placeholder="Copy Link"
                          ref="textToCopyformUpdate"
                          dense
                          readonly
                        ></v-text-field>
                        <v-col cols="1" xs="1" sm="1" md="1" lg="1">
                          <v-btn
                            color="primary"
                            fab
                            x-small
                            dark
                            @click="copyTextformUpdate"
                            ><v-icon>mdi-content-copy</v-icon></v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      color="#173053"
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส Exchange Rate*"
                        v-model="formUpdate.id"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-col cols="4">
                    <v-autocomplete
                      v-model="search.masBranchID"
                      :items="dataBranch"
                      outlined
                      dense
                      chips
                      small-chips
                      label="สาขา"
                    ></v-autocomplete>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="4">
                    <v-text-field
                      v-model="search.amount"
                      label="จำนวนเงิน"
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-card-title>
              <v-card-title>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-col cols="2">
                    <v-btn
                      class="btn-color mr-4"
                      dark
                      @click.prevent="saerchDataAdvanced()"
                    >
                      ค้นหา
                    </v-btn>
                    <v-btn
                      color="red"
                      class="mr-4"
                      dark
                      @click="
                        clearSearch(),
                          getDataGlobal(
                            DNS_IP,
                            path,
                            session.data.shopId + '&status=waiting'
                          )
                      "
                    >
                      ยกเลิก
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-card-title>
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:[`item.amount`]="{ item }">
                    {{ formatNumber(item.amount) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          small
                          @click.stop="
                            (dialogView = true),
                              getDataById(item),
                              validate('View');
                          "
                        >
                          <v-icon dark> mdi-qrcode </v-icon>
                        </v-btn>
                      </template>
                      <span>เปิด Qr code</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          small
                          @click.stop="
                            (dialogEdit = true),
                              getDataById(item),
                              validate('UPDATE');
                          "
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          small
                          @click.stop="
                            (dialogDelete = true), getDataById(item);
                          "
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue,
    QrcodeStream
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/qrcode/', // Path Model
      returnLink: '/Tool/CollectQRCode',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Collect QRCode',
          disabled: false,
          href: '/Tool/CollectQRCode'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      camera: 'auto',
      result: null,
      showScanConfirmation: false,
      formRedeem: {
        shopId: '',
        rewardId: '',
        rewardCode: '',
        lineUserId: '',
        totalPoint: '',
        levelName: ''
      },
      selectData: '',
      // End Menu Config
      dataReady: true,
      dataShowQR: false,
      dialogRedeem: false,
      size: 180, // QR Code
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'AGE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogView: false,
      dialogViewAdd: false,
      dialogExchang: false,
      dialogShortcusAdd: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      sss: this.$session.getAll().data.shopId,
      // Search All
      searchAll: '',
      searchAll2: '',
      searchAll1: '',
      // Search Advanced
      search: {
        masBranchID: '',
        amount: ''
      },
      formView: {
        lineName: '',
        linePicture: '',
        rewardName: '',
        rewardSubName: '',
        rewardPictureUrl: '',
        description: ''
      },
      formAdd: {
        productExchangeRateId: '',
        amount: 0,
        refId: '',
        point: 0,
        token: '',
        typeCoin: '',
        status: 'waiting',
        statusMemberCard: 'collect',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        qrCodeURL: '',
        masBranchID: '',
        branchName: '',
        CREATE_DATE: '',
        tel: ''
      },
      formUpdate: {
        id: '',
        productExchangeRateId: '',
        refId: '',
        amount: 0,
        point: 0,
        token: '',
        status: '',
        statusMemberCard: 'collect',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        qrCodeURL: '',
        CREATE_DATE: '',
        LAST_DATE: '',
        masBranchID: '',
        branchName: ''
      },
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'QRcode Id', value: 'id' },
        { text: 'สาขา', value: 'branchName' },
        { text: 'รหัสอัตราแลกเปลี่ยน', value: 'productExchangeRateName' },
        { text: 'จำนวนเงิน', value: 'amount' },
        { text: 'เลขอ้างอิง', value: 'refId' },
        { text: 'เบอร์', value: 'tel' },
        { text: 'สถานะ', value: 'status' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      ProductExchangeRate: [],
      dataItem: [],
      dataBranch: [],
      validAdd: true,
      validUpdate: true,
      dailogViewRedeem: false,
      statusViewRedeem: false,
      alert: true,
      res: [],
      warningLimit: 59000,
      Limit: 60000,
      statusLimit: false,
      datasession: '',
      filterItem: [],
      Exchange: '',
      loadingAdd: false,
      loadingEdit: false,
      dataMember: [],
      dialogPhoneNumber: false,
      // End Data Table Config
      dataFilterTel: {
        nameCustomer: '',
        tel: '',
        name: '',
        picture: ''
      },
      statusChk: true
    }
  },
  async mounted () {
    // console.log('test1', this.$session.getAll().data)
    // console.log('test2', JSON.parse(localStorage.getItem('sessionData')) !== null)
    // console.log('this.session.data.shopId')
    if (this.$session.getAll().data !== undefined) {
      // console.log('not null')
      // alert('1')
      if (this.$session.getAll().data.shopId === this.$route.query.shopId) {
        // alert('1.1')
        if (!this.$session.exists()) {
          // alert('1.1.1')
          this.$session.start()
          this.$session.set(
            'data',
            JSON.parse(localStorage.getItem('sessionData'))
          )
          location.reload()
        } else {
          await this.checkQuery()
        }
      } else {
        if (this.$route.query.rewardCode) {
          // alert('1.2.1')
          this.$router.push(
            '/Core/Login?access=KNYW6L9LPgSgWPvMzGUBPhPXH52ZdndSpq4Ez8SXMzGu3tBvfEFCrYKK86usU7FE47VKpuVCqe3YPA2CHsnZXshcsKG7A4ZaEWUW&callBack=' +
              this.$route.fullPath
          )
        } else {
          await this.checkQuery()
        }
      }
    } else {
      // console.log('else')
      if (!this.$session.exists()) {
        this.$router.push(
          '/Core/Login?access=KNYW6L9LPgSgWPvMzGUBPhPXH52ZdndSpq4Ez8SXMzGu3tBvfEFCrYKK86usU7FE47VKpuVCqe3YPA2CHsnZXshcsKG7A4ZaEWUW&callBack=' +
            this.$route.fullPath
        )
      } else {
        localStorage.setItem(
          'sessionData',
          JSON.stringify(this.$session.getAll().data)
        )
        // console.log(this.$route.fullPath)
        await this.checkQuery()
      }
    }
    await this.getMember()
    this.chkAdd()
    await this.filter()
  },
  methods: {
    async getMember () {
      this.dataMember = []
      console.log('this.DNS_IP', this.DNS_IP)
      await axios
        .get(
          this.DNS_IP +
            '/member/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(response => {
          let rs = response.data
          console.log('dataMem', rs)
          if (rs.status === false) {
            this.dataMember = []
          } else {
            this.dataMember = rs
            console.log('dataMem', this.dataMember)
          }
        })
    },
    chkNumber () {
      let result = this.dataMember.filter(el => el.tel === this.formAdd.tel)
      if (result.length === 0) {
        this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
      }
      console.log('result', result)
    },
    async checkShortcut () {
      await this.getProductExchangeRate()
      await this.getDataBranch()
      this.dataReady = false
      // Get Data
      await this.getDataGlobal(
        this.DNS_IP,
        this.path,
        this.session.data.shopId + '&status=waiting',
        this.returnLink
      )
      const shortcutExchangeId = this.$route.query.shortcutExchangeId
      const shortcutAmount = this.$route.query.shortcutAmount
      console.log('ProductExchangeRate', this.ProductExchangeRate)
      const itemShortcut = this.ProductExchangeRate.filter(row => {
        return parseInt(row.value) === parseInt(shortcutExchangeId)
      })
      if (itemShortcut.length > 0) {
        this.dialogAdd = true
        this.formAdd.amount = shortcutAmount
        this.addExchange(itemShortcut[0])
        this.validate('ADD')
        this.chkaddFilterItem()
        this.chkaddProductExchangeRate()
      }
    },
    async checkQuery () {
      if (this.$route.query.mode === 'shortcut') {
        this.checkShortcut()
      } else {
        if (this.$route.query.shopId) {
          if (this.$route.query.shopId === this.$session.getAll().data.shopId) {
            await this.chkViewRedeem()
          } else {
            this.$swal(
              'ผิดพลาด',
              'รางวัลนี้ไม่ได้อยู่ใน ร้านค้าของคุณ',
              'error'
            )
            this.getProductExchangeRate()

            this.getDataBranch()
            this.dataReady = false
            // Get Data
            await this.getDataGlobal(
              this.DNS_IP,
              this.path,
              this.session.data.shopId + '&status=waiting',
              this.returnLink
            )
          }
        } else {
          this.getProductExchangeRate()
          this.getDataBranch()
          this.dataReady = false
          // Get Data
          await this.getDataGlobal(
            this.DNS_IP,
            this.path,
            this.session.data.shopId + '&status=waiting',
            this.returnLink
          )
        }
      }
    },
    chkaddFilterItem () {
      if (this.filterItem.length === 1) {
        this.addExchange(this.filterItem)
      }
    },
    chkaddProductExchangeRate () {
      if (this.ProductExchangeRate.length === 1) {
        this.addExchange(this.ProductExchangeRate)
      }
    },
    addExchange (item) {
      if (this.session.data.userTypeGroup === 'Operation') {
        if (this.filterItem.length === 1) {
          this.formAdd.productExchangeRateId = item[0].value
          this.formAdd.typeCoin = item[0].typeCoin
          this.Exchange = item[0].text
        } else {
          this.formAdd.productExchangeRateId = item.value
          this.formAdd.typeCoin = item.typeCoin
          this.Exchange = item.text
        }
      } else {
        if (this.ProductExchangeRate.length === 1) {
          this.formAdd.productExchangeRateId = item[0].value
          this.formAdd.typeCoin = item[0].typeCoin
          this.Exchange = item[0].text
        } else {
          this.formAdd.productExchangeRateId = item.value
          this.formAdd.typeCoin = item.typeCoin
          this.Exchange = item.text
        }
      }

      console.log('item', item)
    },
    async filter () {
      this.filterItem = []
      this.ProductExchangeRate.forEach(element => {
        JSON.parse(element.userId).forEach(el => {
          if (el === this.session.data.userId) {
            this.filterItem.push(element)
          }
        })
      })
    },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          console.log(this.dataBranch)
          if (this.dataBranch.length === 1) {
            this.formAdd.masBranchID = s.value
            this.formAdd.branchName = s.text
            console.log('masBranch', this.formAdd.masBranchID)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async chkViewRedeem () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/rewardCode/' +
            'get?rewardId=' +
            this.$route.query.rewardId +
            '&rewardCode=' +
            this.$route.query.rewardCode +
            '&redeemStatus=get&shopId=' +
            this.$route.query.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('data', response)
          if (response.data.status === false) {
            this.dailogViewRedeem = true
            this.statusViewRedeem = false
          } else {
            this.dailogViewRedeem = true
            this.statusViewRedeem = true
            this.formView.lineName = response.data[0].lineName
            this.formView.linePicture = response.data[0].linePicture
            this.formView.rewardName = response.data[0].name
            this.formView.rewardSubName = response.data[0].subName
            this.formView.rewardPictureUrl = response.data[0].pictureUrl
            this.formView.totalPoint = response.data[0].totalPoint
            this.formView.currentPoint = response.data[0].currentPoint
            this.formView.levelName = response.data[0].levelName
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    closeViewRedeem () {
      this.$router.push('/Tool/CollectQRCode')
      location.reload()
    },
    async updateUseRerard () {
      const url1 = this.DNS_IP + '/rewardCode/edit'
      let config1 = {
        headers: {
          shopId: this.$route.query.shopId,
          lineId: this.$route.query.lineUserId,
          LAST_USER: this.$session.getAll().data.userName
        }
      }
      let dt1 = {
        rewardCode: this.$route.query.rewardCode,
        rewardId: this.$route.query.rewardId,
        redeemStatus: 'use',
        supply: 'redeem',
        des: this.formView.description
      }
      await axios.post(url1, dt1, config1).then(async response => {
        if (response.data.status === true) {
          this.$swal({
            title: 'เรียบร้อย',
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: 'ตกลง'
          })
            .then(async result => {
              console.log(result)
              // this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.$router.push('/Tool/CollectQRCode')
              location.reload()
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log(error)
              // this.$router.push('/Tool/CollectQRCode')
              // location.reload()
              // this.dataReady = true
            })
        } else {
          this.$swal('ผิดพลาด', response.data.message, 'error')
          this.$router.push('/Tool/CollectQRCode')
          location.reload()
        }
      })
    },
    async onInit (promise) {
      try {
        await promise
      } catch (e) {
        console.error(e)
      } finally {
        this.showScanConfirmation = this.camera === 'off'
      }
    },

    async onDecode (content) {
      this.result = content
      if (content) {
        console.log(content)
        await this.pause(content)
        // await this.timeout(500)
        // await this.unpause()
      }
    },

    unpause () {
      this.camera = 'auto'
    },

    pause (content) {
      this.camera = 'off'
      this.timeout(500)
      this.$router.push(content)
      // this.showScanConfirmation = false
      // this.dialogRedeem = false
      location.reload()
      // window.location = content
      // this.$router.push({
      //   path: content
      // })
    },

    timeout (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    copyText () {
      let textToCopy = this.$refs.textToCopy.$el.querySelector('input')
      textToCopy.select()
      document.execCommand('copy')
    },
    copyTextformUpdate () {
      let textToCopyformUpdate = this.$refs.textToCopyformUpdate.$el.querySelector(
        'input'
      )
      textToCopyformUpdate.select()
      document.execCommand('copy')
    },
    copyTextformView () {
      let textToCopyformUpdate = this.$refs.textToCopyformView.$el.querySelector(
        'input'
      )
      textToCopyformUpdate.select()
      document.execCommand('copy')
    },
    copyTextformViewAdd () {
      let textToCopyformUpdate = this.$refs.textToCopyformViewAdd.$el.querySelector(
        'input'
      )
      textToCopyformUpdate.select()
      document.execCommand('copy')
    },

    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getProductExchangeRate () {
      // Clear Data ทุกครั้ง
      this.ProductExchangeRate = []
      // console.log('getDataTypeGroup')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/productExchangeRate/' +
            'get?shopId=' +
            this.session.data.shopId
          // {
          //   headers: {
          //     'Application-Key': this.$session.getAll().ApplicationKey
          //   }
          // }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId
            s.text = d.name
            s.exchangeRate = d.exchangeRate
            s.userId = d.userId
            s.typeCoin = d.typeCoin
            d = s
            console.log(d)
            this.ProductExchangeRate.push(d)
          }
          console.log('this.ProductExchangeRate : ', this.ProductExchangeRate)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?id=' +
        this.searchAll +
        '&productExchangeRateId=' +
        this.searchAll +
        '&amount=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
      console.log('search', search)
    },
    async saerchDataAdvanced () {
      var search = ''
      this.dataItem = []
      for (var key in this.search) {
        if (this.search[key]) {
          if (search !== '') {
            search += '&'
          }
          search += key + '=' + this.search[key]
        }
      }
      console.log('search', search)
      this.saerchDataAdvancedGlobal(
        this.DNS_IP,
        this.path,
        search,
        this.session.data.shopId + '&status=waiting',
        this.returnLink
      )
      console.log('search', search)
      //   console.log(this.saerchDataAdvancedGlobal(this.DNS_IP, this.path)) xxxx
    },
    async getDataById (item) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'id',
        item.id,
        this.returnLink
      )
    },
    conF () {
      this.$swal({
        title: 'ต้องการด้วยเบอร์โทรศัพท์ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(result => {
        var data = {
          refId: (this.formAdd.refId || '').toString().replace(/\s+/g, ''),
          shopId: this.$session.getAll().data.shopId,
          tel: this.formAdd.tel
            .split('-')
            .join('')
            .trim(),
          Amount: this.formAdd.amount,
          exchangRateId: this.formAdd.productExchangeRateId.toString(),
          masBranchID: this.formAdd.masBranchID,
          branchName: this.formAdd.branchName,
          source: false
        }
        console.log('data', data)
        axios.post(this.DNS_IP + '/POSapi', data).then(response => {
          console.log('POSapi"', response)

          this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
        })
        // alert('if')
        this.clearData()
        this.dialogPhoneNumber = false
        this.dialogAdd = false
        this.dataReady = true
      })
    },
    async addData () {
      if (this.formAdd.tel !== '') {
        let result1 = this.dataMember
          .map(el =>
            el.tel
              .split('-')
              .join('')
              .trim()
          )
          .filter(
            value =>
              value ===
              this.formAdd.tel
                .split('-')
                .join('')
                .trim()
          )
        if (result1.length === 0) {
          this.$swal(
            'ไม่พบบัญชีผู้ใช้',
            'กรุณาตรวจสอบหมายเลขโทรศัพท์',
            'error'
          )
        } else {
          this.dialogPhoneNumber = true
          this.dialogAdd = false
          let a = []
          a = this.dataMember.filter(
            a =>
              a.tel
                .split('-')
                .join('')
                .trim() === result1[0]
          )
          // let a = this.dataMember.filter(el => {
          //   el.tel.split('-').join('').trim() === result1[0]
          // })
          // console.log('dtM', result1)
          // console.log('dtM', this.dataMember)
          // console.log('dtM222232323', this.dataFilterTel)
          console.log('dtM22', a)
          this.dataFilterTel.nameCustomer = a[0].nameCustomer
          this.dataFilterTel.name = a[0].name
          this.dataFilterTel.tel = a[0].tel
          this.dataFilterTel.picture = a[0].picture
        }
      } else {
        this.dataReady = false
        this.dataShowQR = false
        this.$swal({
          title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async result => {
            this.loadingAdd = true
            const today = new Date()
            const date =
              today.getFullYear() +
              '' +
              (today.getMonth() + 1) +
              '' +
              today.getDate()
            const time =
              today.getHours() +
              '' +
              today.getMinutes() +
              '' +
              today.getSeconds()
            const token = date + '' + time
            var md5 = require('md5')
            var tokenKey = md5(token)
            var productExchangeRateId = this.formAdd.productExchangeRateId

            var dateExchange = this.ProductExchangeRate.filter(function (el) {
              return el.value === productExchangeRateId
            })
            let _this = this
            var dateBranchs = this.dataBranch.filter(function (el) {
              return el.value === _this.formAdd.masBranchID
            })
            var point = ''
            if (dateExchange[0].exchangeRate === 0) {
              point = 0
            } else {
              point =
                parseInt(this.formAdd.amount) / dateExchange[0].exchangeRate
            }

            this.formAdd.branchName = dateBranchs[0].text
            this.formAdd.CREATE_USER = this.session.data.userName
            this.formAdd.LAST_USER = this.session.data.userName
            this.formAdd.point = parseInt(point)
            this.formAdd.token = tokenKey
            this.formAdd.shopId = this.$session.getAll().data.shopId
            this.formAdd.qrCodeURL = `https://liff.line.me/${process.env.VUE_APP_LIFF_ID}/collect?shopId=${this.formAdd.shopId}&token=${this.formAdd.token}`
            delete this.formAdd['CREATE_DATE']
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + this.path + "add",
                this.formAdd
              )
              .then(async response => {
                // Debug response
                console.log('addDataGlobal DNS_IP + PATH + "add"', response)

                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                this.formAdd.CREATE_DATE = new Date()
                  .toISOString()
                  .substr(0, 10)
                this.dialogViewAdd = true
              })
              // eslint-disable-next-line handle-callback-err
              .catch(error => {
                console.log('error function addDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
                this.dataReady = true
              })
            this.loadingAdd = false
          })
          .catch(error => {
            console.log('error function addData : ', error)
            this.dataReady = true
          })
      }
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          this.formUpdate.amount = parseInt(this.formUpdate.amount)
          var productExchangeRateId = this.formUpdate.productExchangeRateId
          var dateExchange = this.ProductExchangeRate.filter(function (el) {
            return el.value === productExchangeRateId
          })
          var point = ''
          if (dateExchange[0].exchangeRate === 0) {
            point = 0
          } else {
            point =
              parseInt(this.formUpdate.amount) / dateExchange[0].exchangeRate
          }
          var ID = this.formUpdate.id
          this.formUpdate.point = parseInt(point)
          delete this.formUpdate['id']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['CREATE_USER']
          delete this.formUpdate['productExchangeRateName']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + ID,
              this.formUpdate
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId + '&status=waiting',
                this.returnLink
              )
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.id)
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.id,
        this.session.data.shopId,
        '&status=waiting',
        this.returnLink
      )
      this.getProductExchangeRate()
      this.getDataBranch()
    },
    async clearData () {
      this.Exchange = ''
      this.formAdd.productExchangeRateId = ''
      this.formAdd.amount = 0
      this.formAdd.point = 0
      this.formAdd.token = ''
      this.formAdd.status = 'waiting'
      this.formAdd.statusMemberCard = 'collect'
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.qrCodeURL = ''
      this.formAdd.branchName = ''
      this.formAdd.masBranchID = ''
      this.formAdd.CREATE_DATE = ''
      this.formAdd.CREATE_DATE = ''
      this.formAdd.tel = ''
    },
    async clearDataUpdate () {
      this.formUpdate.id = ''
      this.formUpdate.productExchangeRateId = ''
      this.formUpdate.amount = 0
      this.formUpdate.point = 0
      this.formUpdate.token = ''
      this.formUpdate.status = ''
      this.formUpdate.statusMemberCard = 'collect'
      this.formUpdate.CREATE_USER = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.shopId = ''
      this.formUpdate.qrCodeURL = ''
      this.formUpdate.CREATE_DATE = ''
      this.formUpdate.LAST_DATE = ''
      this.formUpdate.branchName = ''
      this.formUpdate.masBranchID = ''
    },
    clearSearch () {
      this.search.masBranchID = ''
      this.search.amount = ''
    },
    chkAdd () {
      this.res = []
      axios
        .get(this.DNS_IP + '/only_shop/get?shopId=' + this.session.data.shopId)
        .then(response => {
          let rs = response.data[0].billingPlan
          console.log('rs', rs)
          if (rs === 'billing') {
            axios
              .get(
                this.DNS_IP +
                  '/member/Member?shopId=' +
                  this.session.data.shopId
              )
              .then(response => {
                const rs = response.data
                console.log(rs)
              })
          } else {
            axios
              .get(
                this.DNS_IP +
                  '/member/Member?shopId=' +
                  this.session.data.shopId
              )
              .then(response => {
                this.res = response.data
                if (this.res.length >= this.Limit) {
                  this.statusLimit = true
                } else {
                  this.statusLimit = false
                }
              })
          }
        })
    },
    changePacket () {
      this.$refs.modal.chkPlane()
    }
  }
}
</script>
<style scoped>
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 20px;
}
.point {
  font-size: 100px;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
      display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#subtext {
  color: #173053;
  font-size: 20px !important;
  font-weight: bold;
}
#margit_vector {
  position: absolute;
  left: 42.03%;
  right: 42.75%;
  top: 15%;
  color: #ffa610;
  size: 50px;
}
#text_awesome {
  position: absolute;
  top: 20%;
  font-size: 40px;
  line-height: 23px;
  font-weight: bold;
  color: #173053;
}
#text_a {
  font-weight: bold;
  color: #173053;
  align-items: center;
  text-align: center;
  font-size: 30px !important;
}
#text_b {
  font-weight: bold;
  font-size: 50px !important;
  align-items: center;
  text-align: center;
  color: #ffa000;
}
.avatar {
  margin: 1rem;
}
.divBtn {
  margin-top: 1rem;
}
.scoll {
  overflow-y: hidden;
  overflow-x: hidden;
}
>>> .v-dialog {
  /* overflow-y: hidden !important; */
  overflow-x: hidden !important;
}
.v-card-chk {
  position: relative;
  width: 550px;
  height: 545px;

  /* Secondary/ Primary White */

  background: #ffffff;
  border-radius: 20px;
}
h1 {
  width: 96px;
  height: 29px;
  left: calc(50% - 96px / 2 + 1px);
  top: calc(50% - 32px / 2 + 5.5px);

  font-family: "Kanit";
  font-style: normal;
  font-weight: 100;
  font-size: 42px;
  line-height: 32px;

  letter-spacing: -0.02em;

  /* color: #1b2559; */
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/CollectQRCode.vue